import React from "react";
import { Helmet } from "react-helmet";
import SiteBreadcrumb from "../../../components/Common/Breadcumb";
import OffWrap from "../../../components/Layout/Header/OffWrap";
import Footer from "../../../components/Layout/Footer/FooterStyleOne";
import SearchModal from "../../../components/Layout/Header/SearchModal";
import ScrollToTop from "../../../components/Common/ScrollTop";
import Newsletter from "../../../components/Common/Newsletter";
import Header from "../../../components/Layout/Header/Header";
import ServiceCard from "../../../components/Service/ServiceCard";
import { Link } from "react-router-dom";
import IndustriesSection from '../../../components/IndustriesSection';
import { FaChartLine, FaCloud, FaCogs, FaMobileAlt, FaSyncAlt, FaLightbulb, FaUsers, FaRobot } from "react-icons/fa";

import bannerbg from "../../../assets/img/breadcrumbs/sssss.jpg";
import Logo from "../../../assets/img/logo/dark-logo.png";
import footerLogo from "../../../assets/img/logo/lite-logo.png";
import favIcon from "../../../assets/img/fav.png";

const serviceCards = [
  {
    icon: <FaChartLine size={80} color="var(--brand-primary)" />,
    title: "Digital Strategy Development",
    description: "Craft a comprehensive digital transformation roadmap. Align technology initiatives with your business vision and goals.",
  },
  {
    icon: <FaCloud size={80} color="var(--brand-primary)" />,
    title: "Cloud Migration & Enablement",
    description: "Move to the cloud with confidence. Enhance agility, scalability, and cost efficiency for your organization.",
  },
  {
    icon: <FaCogs size={80} color="var(--brand-primary)" />,
    title: "Process Automation & Optimization",
    description: "Streamline workflows and boost productivity with automation. Reduce manual effort and operational costs.",
  },
  {
    icon: <FaMobileAlt size={80} color="var(--brand-primary)" />,
    title: "Customer Experience Transformation",
    description: "Deliver seamless, engaging digital experiences. Increase customer satisfaction and loyalty across all channels.",
  },
  {
    icon: <FaSyncAlt size={80} color="var(--brand-primary)" />,
    title: "Legacy System Modernization",
    description: "Upgrade outdated systems to modern platforms. Improve performance, security, and integration capabilities.",
  },
  {
    icon: <FaLightbulb size={80} color="var(--brand-primary)" />,
    title: "Innovation & Emerging Tech",
    description: "Leverage AI, IoT, and other emerging technologies. Stay ahead of the curve and drive business innovation.",
  },
  {
    icon: <FaUsers size={80} color="var(--brand-primary)" />,
    title: "Change Management & Training",
    description: "Support your team through digital change. Provide training and resources for successful adoption.",
  },
  {
    icon: <FaRobot size={80} color="var(--brand-primary)" />,
    title: "Data Analytics & Intelligence",
    description: "Unlock insights from your data. Make informed decisions with advanced analytics and business intelligence.",
  },
];

const DigitalTransformation = () => {
  return (
    <React.Fragment>
      <Helmet>
        <link rel="icon" href={favIcon} />
        <title>Digital Transformation Consultation - Syrol Tech</title>
        <meta name="description" content="Expert digital transformation consultation services. Get tailored strategies for your digital journey and business growth." />
      </Helmet>
      <OffWrap />
      <Header
        parentMenu="pages"
        secondParentMenu="others"
        headerNormalLogo={Logo}
        headerStickyLogo={Logo}
        CanvasLogo={Logo}
        mobileNormalLogo={Logo}
        CanvasClass="right_menu_togle hidden-md"
        headerClass="full-width-header header-style1 home8-style4"
        TopBar="enable"
        TopBarClass="topbar-area home8-topbar"
        emailAddress="hello@syroltech.com"
        Location="Abuja, Nigeria"
      />
      <SiteBreadcrumb
        pageTitle="Digital Transformation Consultation"
        pageName="Digital Transformation"
        breadcrumbsImg={bannerbg}
      />
      {/* Hero Section - Modern, full-width with background image and overlay */}
      <section className="consultation-hero-section position-relative w-100" style={{minHeight: '420px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: `url(${bannerbg}) center/cover no-repeat`}}>
        <div className="hero-overlay" style={{position: 'absolute', inset: 0, background: 'rgba(10, 18, 32, 0.72)', zIndex: 1}}></div>
        <div className="container position-relative" style={{zIndex: 2, maxWidth: '900px', padding: '3rem 1rem', textAlign: 'left'}}>
          <h1 style={{color: '#fff', fontWeight: 700, fontSize: '2.6rem', lineHeight: 1.15, marginBottom: '1.2rem'}}>Accelerate Your Digital Transformation</h1>
          <p style={{color: '#fff', fontSize: '1.25rem', maxWidth: '600px', marginBottom: '2.2rem'}}>Drive innovation and business growth with our digital transformation consultation. We help you leverage technology to streamline processes and create new value.</p>
          <Link to="/consultation" className="readon orange-btn" style={{padding: '12px 28px', fontSize: '1rem', borderRadius: '6px', fontWeight: 700, textDecoration: 'none', display: 'inline-block', background: '#111', color: '#fff'}}>Request A Free Proposal</Link>
        </div>
      </section>
      <div className="rs-contact style1 event-bg pt-110 md-pt-10 pb-100 md-pb-80">
        <div className="container pb-66 md-pb-46">
          <h2 className="service-title mb-32">Our Digital Transformation Services</h2>
          {serviceCards.map((card, idx) => (
            <ServiceCard
              key={idx}
              icon={card.icon}
              title={card.title}
              description={card.description}
            />
          ))}
        </div>
      </div>
      <IndustriesSection />
      <Newsletter
        sectionClass="rs-newsletter style1 orange-color event-bg mb--90 sm-mb-0 sm-pb-80"
        titleClass="title mb-0 white-color"
      />
      <Footer
        footerClass="rs-footer home9-style main-home"
        footerLogo={footerLogo}
      />
      <SearchModal />
      <ScrollToTop scrollClassName="scrollup orange-color" />
    </React.Fragment>
  );
};

export default DigitalTransformation; 